export type NavIcon = "home" | "star" | "compass" | "grid" | "clock" | "book" | "image" | "info";

export type NavigationItem = {
  id: string;
  label: string;
  icon: NavIcon;
  showInHeader: boolean;
  showInToc: boolean;
};

export const siteContent = {
  hero: {
    eyebrow: "WINNIE.TW · EDTECH PORTFOLIO",
    title: "Winnie EdTech Lab",
    subtitle: "AI × 教學 × 科技 × 創作",
    description: "把研習現場、課堂活動與 AI 教育想像，整理成真正能使用、能維護、能分享的數位作品。"
  },
  sections: {
    featured: {
      kicker: "精選推薦",
      title: "精選作品",
      description: "從課堂、研習到自主學習，整理幾個最適合先認識 Winnie EdTech Lab 的代表作品。"
    },
    latest: {
      kicker: "最近更新",
      title: "最新整理"
    },
    categories: {
      kicker: "探索入口",
      title: "依使用情境快速找到作品"
    },
    resources: {
      kicker: "延伸收藏",
      title: "好用資源分享",
      description: "把值得收藏的文章、教學影片、GitHub 專案與實用工具整理在一起，讓教學靈感可以被快速取用。"
    },
    gallery: {
      kicker: "靈感圖牆",
      title: "AI 教學圖卡輪播",
      description: "用一張張圖卡整理 AI 名詞、教學概念與研習素材，快速補充課堂與備課靈感。"
    },
    about: {
      kicker: "關於 Winnie EdTech Lab",
      title: "把教學創意變成可分享、可使用的作品",
      description:
        "Winnie EdTech Lab 關注 AI 教育應用、教師研習、互動教材與遊戲化學習設計。這裡整理的作品，都是為了讓教師更容易把科技帶進課堂，也讓學習活動更清楚、更有參與感。"
    }
  },
  navigation: [
    { id: "top", label: "首頁", icon: "home", showInHeader: true, showInToc: true },
    { id: "featured", label: "精選", icon: "star", showInHeader: true, showInToc: true },
    { id: "latest", label: "最新", icon: "clock", showInHeader: true, showInToc: true },
    { id: "categories", label: "分類", icon: "compass", showInHeader: true, showInToc: true },
    { id: "resources", label: "資源", icon: "book", showInHeader: true, showInToc: true },
    { id: "gallery", label: "圖牆", icon: "image", showInHeader: true, showInToc: true },
    { id: "about", label: "關於", icon: "info", showInHeader: true, showInToc: true }
  ] satisfies NavigationItem[]
};
